import { LoginPage, MsalLoginForm } from "am-tax-fe-core";
import BgImage from "../../assets/images/login_background.jpg";
import logo from "../../assets/images/logo.png";
import { Image } from "@chakra-ui/react";

export const UnauthenticatedLandingPage = () => {
    return (
        <LoginPage bgImage={`url(${BgImage})`} logo={<Image src={logo} alt="A&M" maxH="6rem" />} appName={import.meta.env.VITE_APP_NAME}>
            <MsalLoginForm />
        </LoginPage>
    );
};
